import axios from 'axios';
import { AuditFilterModel } from 'src/investigate/Content/routes/admin/routes/AuditManagementPage/AuditManagementPage';
import { AuditLog } from '../models/common-types';

const prefix = '/api/osint';

export class AuditAPI implements AuditApi {
    async fetchAuditLogs(auditFilter: AuditFilterModel): Promise<{ logs: AuditLog[]; totalCount: number }> {
        try {
            const response = await axios.post(`${prefix}/audit`, auditFilter);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async togglePriority(id: number, priority: boolean): Promise<AuditLog> {
        try {
            const response = await axios.put(`${prefix}/audit/${id}/preferences`, { priority });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async exportAuditLogs(): Promise<any> {
        try {
            const response = await axios.get(`${prefix}/audit/export`, { responseType: 'blob' });
            const url = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.download = 'audit.csv';
            link.href = url;
            link.click();
            return null;
        } catch (error) {
            throw error;
        }
    }
}

export interface AuditApi {
    fetchAuditLogs(auditFilter: AuditFilterModel): Promise<{ logs: AuditLog[]; totalCount: number }>;
    togglePriority(id: number, priority: boolean): Promise<AuditLog>;
    exportAuditLogs(): Promise<any>;
}
